var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5941 5.26868C22.0173 4.6919 21.1097 4.64754 20.4821 5.13558L20.3313 5.26868L9.59998 16L20.3313 26.7314C20.9562 27.3563 21.9693 27.3563 22.5941 26.7314C23.1709 26.1546 23.2152 25.2471 22.7272 24.6194L22.5941 24.4687L14.1267 16L22.5941 7.53142C23.1709 6.95465 23.2152 6.04708 22.7272 5.41941L22.5941 5.26868Z",
    fill: "#1B0076"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevronLeft.3ac404a0.svg";
export { ForwardRef as ReactComponent };